import configs from 'configs';
import request from 'functions/api/request';
import { authHeaders } from 'functions/authHeader';

const apiUrl = configs.beApiUrl;

const getConfiguration = async ({ userWixId, provider = null }) => {
  const requestOptions = {
    url: `${apiUrl}/configuration${userWixId ? `/${userWixId}` : ''}`,
    qs: { provider },
    headers: await authHeaders(),
    json: true,
  };

  try {
    return await request.get(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while getting app configuration:', ex);
    throw ex;
  }
};

const updateUserConfiguration = async ({ userWixId, data }) => {
  const requestOptions = {
    url: `${apiUrl}/configuration/${userWixId}`,
    headers: await authHeaders(),
    data,
    json: true,
  };

  try {
    // actually patch method; meaning data is merged with existing DB record
    return await request.post(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while getting app configuration:', ex);
    throw ex;
  }
};

export const appConfigurationApi = {
  getConfiguration,
  updateUserConfiguration,
};
